var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialUiIcon2018088F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.65214L30.5 0.992146V18.3121L20.5 24.0855L15.5 21.1988L25.5 15.4255V9.65214L15.5 15.4255V9.65214Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.1988V26.9721L25.5 32.7455V26.9721L15.5 21.1988Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 32.7455L40.5001 24.0855V12.5388L35.5001 15.4255V21.1988L25.5001 26.9721V32.7455ZM35.5001 9.65214V3.87881L40.5001 0.992146V6.76548L35.5001 9.65214Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.3122V0.992188L15.5 9.65218V15.4255L5.5 9.65218V21.1988L0.5 18.3122Z",
    fill: "#00B0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 31.875,
    fill: "white",
    transform: "translate(0.5 0.992188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUiIcon2018088F);
export default __webpack_public_path__ + "static/media/material-ui-icon.2018088f.a34d374ccf7bb0882eab12f09cf19751.svg";
export { ForwardRef as ReactComponent };